export default __webpack_public_path__ + "static/media/linkdlnFooter.376f4fd6.svg";